/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetAnimalVaccinationStatusQueryResponse, GetAnimalVaccinationStatusPathParams, GetAnimalVaccinationStatusQueryParams, GetAnimalVaccinationStatus400, GetAnimalVaccinationStatus401, GetAnimalVaccinationStatus403, GetAnimalVaccinationStatus404, GetAnimalVaccinationStatus409, GetAnimalVaccinationStatus500 } from "../../types/livestockController/GetAnimalVaccinationStatus.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getAnimalVaccinationStatus } from "../../client/livestockController/getAnimalVaccinationStatus.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getAnimalVaccinationStatusQueryKey = (organizationId: GetAnimalVaccinationStatusPathParams["organizationId"] | undefined, animalId: GetAnimalVaccinationStatusPathParams["animalId"] | undefined, params?: GetAnimalVaccinationStatusQueryParams) => [{ url: '/api/organizations/:organizationId/livestock/animals/:animalId/vaccination-status', params: {organizationId:organizationId,animalId:animalId} }, ...(params ? [params] : [])] as const

export type GetAnimalVaccinationStatusQueryKey = ReturnType<typeof getAnimalVaccinationStatusQueryKey>

export function getAnimalVaccinationStatusQueryOptions(organizationId: GetAnimalVaccinationStatusPathParams["organizationId"] | undefined, animalId: GetAnimalVaccinationStatusPathParams["animalId"] | undefined, params?: GetAnimalVaccinationStatusQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getAnimalVaccinationStatusQueryKey(organizationId, animalId, params)
        return queryOptions<GetAnimalVaccinationStatusQueryResponse, ResponseErrorConfig<GetAnimalVaccinationStatus400 | GetAnimalVaccinationStatus401 | GetAnimalVaccinationStatus403 | GetAnimalVaccinationStatus404 | GetAnimalVaccinationStatus409 | GetAnimalVaccinationStatus500>, GetAnimalVaccinationStatusQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && animalId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getAnimalVaccinationStatus(organizationId!, animalId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Per-animal standing against every active vaccination rule (due, upcoming, too young, window missed, done)
 * {@link /api/organizations/:organizationId/livestock/animals/:animalId/vaccination-status}
 */
export function useGetAnimalVaccinationStatus<TData = GetAnimalVaccinationStatusQueryResponse, TQueryData = GetAnimalVaccinationStatusQueryResponse, TQueryKey extends QueryKey = GetAnimalVaccinationStatusQueryKey>(organizationId: GetAnimalVaccinationStatusPathParams["organizationId"] | undefined, animalId: GetAnimalVaccinationStatusPathParams["animalId"] | undefined, params?: GetAnimalVaccinationStatusQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetAnimalVaccinationStatusQueryResponse, ResponseErrorConfig<GetAnimalVaccinationStatus400 | GetAnimalVaccinationStatus401 | GetAnimalVaccinationStatus403 | GetAnimalVaccinationStatus404 | GetAnimalVaccinationStatus409 | GetAnimalVaccinationStatus500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getAnimalVaccinationStatusQueryKey(organizationId, animalId, params)
         

         const query = useQuery({
          ...getAnimalVaccinationStatusQueryOptions(organizationId, animalId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetAnimalVaccinationStatus400 | GetAnimalVaccinationStatus401 | GetAnimalVaccinationStatus403 | GetAnimalVaccinationStatus404 | GetAnimalVaccinationStatus409 | GetAnimalVaccinationStatus500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}